module.exports = __webpack_public_path__ + "static/media/btn-start.d7c9c367.png";